"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateConfirmPasswordUtil = exports.validatePasswordUtil = exports.MAX_PASSWORD_LENGTH = exports.MIN_PASSWORD_LENGTH = void 0;
exports.MIN_PASSWORD_LENGTH = 6;
exports.MAX_PASSWORD_LENGTH = 20;
/**
 * Returns an error message if something went wrong.
 * Returns null if successful
 */
const validatePasswordUtil = (password) => {
    if (!password) {
        return null;
    }
    else if (password.length < exports.MIN_PASSWORD_LENGTH) {
        return `Password must be at least ${exports.MIN_PASSWORD_LENGTH} characters`;
    }
    else if (password.length > exports.MAX_PASSWORD_LENGTH) {
        return `Password cannot be longer than ${exports.MAX_PASSWORD_LENGTH} characters`;
    }
    else if (!/[\S]/.test(password)) {
        return `Password cannot contain any spaces`;
    }
    else if (!/[a-z]+/.test(password)) {
        return 'Password must contain one or more lower-case alphabetic characters';
    }
    else if (!/[A-Z]+/.test(password)) {
        return 'Password must contain at least one or more upper-case alphabetic characters';
    }
    else if (!/[^A-Za-z0-9]+/.test(password)) {
        return 'Password must contain at least one special character';
    }
    else if (!/[0-9]+/.test(password)) {
        return 'Password must contain at least one numeric character';
    }
    else {
        return null; // #YOUDIDIT
    }
};
exports.validatePasswordUtil = validatePasswordUtil;
/**
 * Returns an error message if something went wrong.
 * Returns null if successful
 */
const validateConfirmPasswordUtil = (confirmPassword, otherPassword) => {
    if (!confirmPassword) {
        return null;
    }
    else {
        if (otherPassword === confirmPassword) {
            return null;
        }
        else {
            return 'Entered passwords do not match';
        }
    }
};
exports.validateConfirmPasswordUtil = validateConfirmPasswordUtil;
//# sourceMappingURL=passwords.js.map